export default __webpack_public_path__ + "static/media/google-play.2259cc0c.svg";